export default "__VITE_ASSET__DudnIZC5__"